<template>
	<div class="wrapper">
		<div id="app" :class='[merchant().Theme]'>
			<LoadingScreen :header="getText('LoadingHeader')" :message="loading_message" v-if="isLoading()" />

			<div class="main-content container">
				<Header v-if="!merchant().HideHeader" />

				<router-view />

				<Footer v-if="!merchant().HideFooter" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

import Header from "@/components/general/Header";
import Footer from "@/components/general/Footer";
import LoadingScreen from "@/components/general/LoadingScreen";

// Language / Localization
import LanguageService from "@/common/language.service";

export default {
	name: "App",
	components: {
		Header,
		Footer,
		LoadingScreen
	},
	data() {
		return {
			loading_message: this.getText('LoadingMessage')
		};
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
		getError(key){
			return LanguageService.getError(key);
		},
		...mapGetters(["isLoading", "merchant"])
	}
};
</script>

<style scoped lang="scss">
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins/_breakpoints";

.main-content {
	background-color: white;
	margin-bottom: 40px;
	padding-top: 20px;
	margin-top: 40px;

	@include media-breakpoint-up(md) {
		padding: 50px 70px;
	}
}
</style>
